import { useField } from 'formik';
import { FileUpload } from '../FileUpload';

export const FormikFileUpload: React.FC<{
  name: string;
  accept?: string;
  placeholder?: string;
  tiny?: boolean;
}> = ({ name, accept, placeholder, tiny }) => {
  const [field, meta, helpers] = useField(name);

  return (
    <div>
      <FileUpload
        accept={accept}
        placeholder={placeholder}
        tiny={tiny}
        onFileChange={(file) => helpers.setValue(file)}
      />
      {meta.touched && meta.error && (
        <div className="text-red-500 text-sm mt-1">{meta.error}</div>
      )}
    </div>
  );
};
